exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-c7b96e18]{margin-top:13px}.audio-wrap[data-v-c7b96e18]{padding:8px 10px 11px 14px;width:500px;height:60px;border:1px solid #ddd}.video-wrap[data-v-c7b96e18]{width:406px;height:228px;position:relative}", ""]);

// exports
